const baseUrl = process.env.VUE_APP_BASE_URL
const apiUrl = process.env.VUE_APP_API_URL
const pusher = {
  id: process.env.VUE_APP_PUSHER_APP_ID,
  key: process.env.VUE_APP_PUSHER_APP_KEY,
  cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER
}

const appDefaultName = process.env.VUE_APP_TITLE

export { baseUrl, apiUrl, pusher, appDefaultName }
